import { DotLegalBreadCrumbModel, DotLegalPageHeader } from "@dotlegal/dotlegal-ui-components";
import PageHeaderEditEntityButton, { PageHeaderEditEntityButtonMenuItem } from "@common/components/pageHeaderEditEntityButton/PageHeaderEditEntityButton";
import { useTranslation } from "@localization/useTranslation";
import CreateInternalAssessmentGroupDialog from "../createInternalAssessmentGroupDialog/CreateInternalAssessmentGroupDialog";
import DeleteInternalAssessmentGroupDialog from "../deleteInternalAssessmentGroupDialog/DeleteInternalAssessmentGroupDialog";
import { InternalAssessmentGroupHeaderModel } from "../InternalAssessmentGroups.types";
import useInternalAssessmentGroupHeader from "./InternalAssessmentGroupHeader.hooks";

export interface IInternalAssessmentGroupHeaderProps {
    breadCrumbs: Array<DotLegalBreadCrumbModel>;
    internalAssessmentGroup?: InternalAssessmentGroupHeaderModel;
    showAddRecipientsMenuItem: boolean;
    showDeleteMenuItem: boolean;
    canBeDeleted: boolean;
    onInternalAssessmentGroupUpdated: () => void;
}

function InternalAssessmentGroupHeader(props: IInternalAssessmentGroupHeaderProps) {
    const { translateString } = useTranslation();
    const { showEditDialog, setShowEditDialog, showDeleteDialog, setShowDeleteDialog, onAddRecipientsClick, onDeleted } =
        useInternalAssessmentGroupHeader(props);

    const getEditMenuItems = (): Array<PageHeaderEditEntityButtonMenuItem> => {
        const menuItems: Array<PageHeaderEditEntityButtonMenuItem> = [{ menuItem: translateString("edit"), onClick: () => setShowEditDialog(true) }];

        if (props.showAddRecipientsMenuItem) {
            menuItems.push({ menuItem: translateString("addRecipients"), onClick: onAddRecipientsClick });
        }

        if (props.showDeleteMenuItem) {
            menuItems.push({ menuItem: translateString("delete"), onClick: () => setShowDeleteDialog(true) });
        }

        return menuItems;
    };

    return (
        <>
            <DotLegalPageHeader
                breadCrumbs={props.breadCrumbs}
                rightComponent={props.internalAssessmentGroup && <PageHeaderEditEntityButton menuItems={getEditMenuItems()} />}
            />

            {showEditDialog && props.internalAssessmentGroup && (
                <CreateInternalAssessmentGroupDialog
                    onDialogClose={() => setShowEditDialog(false)}
                    internalAssessmentGroupId={props.internalAssessmentGroup.id}
                    internalAssessmentGroupInProgress={!!props.internalAssessmentGroup.sent}
                    internalAssessmentGroup={{
                        name: props.internalAssessmentGroup.name,
                        description: props.internalAssessmentGroup.description,
                        questionnaireId: props.internalAssessmentGroup.assessmentTemplateId,
                        questionnaireName: props.internalAssessmentGroup.assessmentTemplate,
                        responsibleId: props.internalAssessmentGroup.responsibleId,
                        deadline: props.internalAssessmentGroup.deadline,
                        groupEntityId: props.internalAssessmentGroup.senderId,
                        relations: [],
                    }}
                    onInternalAssessmentGroupUpdated={() => {
                        setShowEditDialog(false);
                        props.onInternalAssessmentGroupUpdated();
                    }}
                />
            )}

            {showDeleteDialog && props.internalAssessmentGroup && (
                <DeleteInternalAssessmentGroupDialog
                    internalAssessmentGroupId={props.internalAssessmentGroup.id}
                    internalAssessmentGroupName={props.internalAssessmentGroup.name}
                    deadline={props.internalAssessmentGroup.deadline}
                    canBeDeleted={props.canBeDeleted}
                    onDialogClose={() => setShowDeleteDialog(false)}
                    onDeleted={onDeleted}
                />
            )}
        </>
    );
}

export default InternalAssessmentGroupHeader;
